<!-- 确认组件 -->
<template>
  <div>
    <div class="chat-card">
      <div class="all-btn">
        <div
          class="item-btn"
          @click="submitFn(item.text, item?.reply)"
          v-for="(item, index) in cardData.data"
          :key="index"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <!-- <div class="send-time">09月01日 16:29</div> -->
  </div>
</template>

<script>
export default {
  name: "ChatConfirmMore",
  components: {},
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    submitFn(text, reply) {
      let sendParams = {
        sendData: {
          type: "ChatSend",
          text,
        },
      };
      //渲染 AIChatting
      this.$emit("sendMsg", sendParams);

      if (reply) {
        let sendParamsr = {
          sendData: {
            type: "ChatText",
            text: reply,
          },
        };
        this.$emit("sendMsgMore", sendParamsr);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 342px;
  border-radius: 12px 12px 12px 0px;
  padding: 10px 24px 10px 12px;
  background: #e8e3fc;
  box-sizing: border-box;
  .chat-text {
    color: $text-color;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23px;
  }
  .all-btn {
    display: flex;
    align-items: center;
    margin-top: 16px;
    .item-btn {
      height: 27px;
      border-radius: 70px;
      background: #ffffff;
      padding: 0 20px;
      display: flex;
      align-items: center;
      font-size: 10px;
      font-weight: 500;
      letter-spacing: 0px;
      color: $text-color;
      margin-right: 10px;
    }
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
</style>
